import ReactTooltip from 'react-tooltip'

import styled, { css } from 'styled-components'

export const Button = styled.div`
  display: flex;
  cursor: pointer;
`

export const StyledSimpleButton = styled.button`
  min-height: 25px;
  min-width: 70px;
  width: 100%;
  color: var(--text-primary);
  padding: 0.75rem 1rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: var(--border-radius-md);

  cursor: pointer;
  background-color: var(--background-button);

  :hover {
    color: var(--text-secondary);
    background-color: var(--background-button-hover);
  }
`

export const StyledReactTooltip = styled(ReactTooltip)`
  ${({ hideTooltipArrow }) => css`
    opacity: 1 !important;
    padding: 3px !important;

    border-radius: var(--border-radius-lg) !important;
    border: 1px solid var(--border-light) !important;
    box-shadow: 2px 2px 8px -3px rgb(0, 16, 38, 0.1) !important;

    &:after {
      content: ${hideTooltipArrow ? 'unset' : ''} !important;
    }
  `}
`

export const ContentWrapper = styled.div``
